import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/mainLayout';
import './style.scss';
import InputWithLabel from '../../components/inputWithLabel';
import LoginBtn from '../../components/buttons/loginBtn';
import { loginApi, resetPassApi, verifyTokenApi } from '../../api/apis/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { addToken } from '../../functions/localStorage';
import { message } from 'antd';
import Loader from '../../components/Loader';
import { getPathAcctoYear } from '../../utils/functions/common';

const CreatePassword = () => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [isFromForgot, setIsFromForgot] = useState(false);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [email, setEmail] = useState("");

  const navigate = useNavigate()

  const handleChangeInput = (e) => {
    const { name, value } = e?.target ?? {};
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" }))
  }

  const validateInputs = () => {
    const errors = {};
    if (!formData?.password?.trim()) {
      errors.password = 'Please Enter Password'
    } else if (formData?.password?.trim()?.length < 6) {
      errors.password = 'Password atleast contains 6 characters'
    }
    if (!formData?.confirmPassword?.trim()) {
      errors.confirmPassword = 'Please Enter Password'
    } else if (formData?.confirmPassword?.trim() !== formData?.password) {
      errors.confirmPassword = 'Both passwords should be same'
    }
    return errors;
  }

  const handleClick = async () => {
    const errors = validateInputs();
    if (Object.keys(errors)?.length) {
      setErrors(errors);
      return;
    }
    setLoading(true)
    try {
      const payload = { email: location?.state?.email || email, password: formData?.password };
      const { data } = isFromForgot ? await resetPassApi(payload) : await loginApi(payload);
      if (data?.status === "success") {
        if (isFromForgot) {
          message.success("Password Reset Successfully")
          navigate(getPathAcctoYear("/login"));
        } else {
          addToken(data?.data?.token)
          if (location?.state?.from?.pathname === getPathAcctoYear("/questions")) {
            navigate(location?.state?.from?.pathname + location?.state?.from?.search)
          } else {
            navigate(getPathAcctoYear(data?.data?.nda_status?.accepted ? "/location" : "/disclaimer"))
          }
        }
      } else {
        setErrors({ submit: data?.message ?? "" })
      }

    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const onKeyDown = (e) => {
    if (e?.keyCode === 13 && !(loading)) {
      handleClick()
    }
  }

  const verifyToken = async (token) => {
    try {
      setTokenLoading(true)
      const response = await verifyTokenApi({ token });
      setTokenLoading(false);
      if (response?.data?.status !== 'success') {
        navigate(getPathAcctoYear("/login"), { replace: true })
        message.error("Token Invalid or expired");
      }else{
        message.success("Token Verified Successfully");
        setEmail(response?.data?.email ?? "");
      }
    } catch (error) {
      setTokenLoading(false);
    }
  }

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const token = search?.get("token")
    if (!location?.state?.email && !token) {
      navigate(getPathAcctoYear("/login"), { replace: true })
    }
    if (token) {
      setIsFromForgot(true);
      verifyToken(token);
    }
  }, [location])

  return (
    <>
      {tokenLoading ?
       <Loader /> :
        <MainLayout>
          <div className='login__section'>
            <h3>
              {isFromForgot ? "Reset" : "Create"} Password
            </h3>
            <br />
            <p className='welcome__description'>
              The Flex Workspace’s Industry First-Ever Quality Standardization
            </p>
            <div className='input__section'>
              <InputWithLabel error={errors?.password} type={"password"} classes={"mt-4"} value={formData?.password} label={"Password"} requried={true} name={"password"} onChange={handleChangeInput} placeholder={"XXXX"} />
              <InputWithLabel error={errors?.confirmPassword} type={"password"} classes={"mt-4"} onKeyDown={onKeyDown} value={formData?.confirmPassword} label={"Confirm Password"} requried={true} name={"confirmPassword"} onChange={handleChangeInput} placeholder={"XXXX"} />
              <LoginBtn onClick={handleClick} disabled={loading} loading={loading} text={"submit"} />
              {errors?.submit ? <p className='error__message'>{errors?.submit}</p> : ""}
            </div>
          </div>
        </MainLayout>
      }
    </>
  )
}

export default CreatePassword